import React from 'react'
import styled from 'styled-components'
import { SERVER_URL } from 'fixtures/api'
import { LightgalleryItem } from "react-lightgallery";

const ic_add = require('App/assets/images/ic_add.png');

const StyledPhoto = styled.img`
  height: ${({ height }) => (height ? height : '51px')};
  width: ${({ width }) => (width ? width :  '71px')};
  object-fit: cover;
  margin-right: ${({ mr }) => (mr ? mr : '0')};
`

const StyledAddBtn = styled.img`
  height: 40px;
  width: 40px;
  margin-right: 20px;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  };
`

const getPhotoUri = (pic, shouldBeBase64) => {
  if (shouldBeBase64) {
    return pic
  } else if (pic.hasOwnProperty('media') && pic.media) {
    return `${SERVER_URL}${pic.media.contentUrl}`
  } else {
    return pic.dmsNodeId ? `${SERVER_URL}${pic.url}` : pic.url
  }
}

export const PhotoItem = ({ pic, shouldBeBase64, previewOnClick, groupGallery = 'any', ...props }) => (
  previewOnClick ? 
    <LightgalleryItem group={groupGallery} src={getPhotoUri(pic, shouldBeBase64)}>
      <StyledPhoto mr={'12px'} src={getPhotoUri(pic, shouldBeBase64)} {...props}/>
    </LightgalleryItem>
  :
  <StyledPhoto mr={'12px'} src={getPhotoUri(pic, shouldBeBase64)} {...props}/>
)

export const PhotoAddBtn = ({ inputId }) => (
  <StyledAddBtn
    src={ic_add}
    onClick={() => document.getElementById(inputId).click()}
  />
)
